import { initialTableShow } from 'utils/settings';
import { access, hasAccess, resources } from 'utils/permissions';

export const RELEASE_TRACKS = ['LATEST', 'LATEST_1', 'LATEST_2'];

export const PLATFORM_TRACK_SLOTS = {
  windows: RELEASE_TRACKS,
  macos: RELEASE_TRACKS,
  linux: ['RECOMMENDED']
};

export const mainTableConf = [
  {
    isSortable: true,
    field: 'platform',
    title: 'Platform',
    show: true,
    width: 160,
    valuesExport: ['platform']
  },
  {
    isSortable: true,
    field: 'version',
    title: 'Version',
    show: true,
    width: 112,
    valuesExport: ['version']
  },
  {
    isSortable: true,
    field: 'status',
    title: 'Status',
    show: true,
    width: 152,
    valuesExport: ['status']
  },
  {
    isSortable: true,
    field: 'releaseTracks',
    title: 'Release Track',
    show: true,
    width: 152,
    valuesExport: ['releaseTracks']
  },
  {
    isSortable: false,
    field: 'numOfFiles',
    title: 'Num Of Files',
    show: true,
    width: 168,
    valuesExport: []
  },
  {
    isSortable: false,
    field: 'appliedTo',
    title: 'Customers',
    show: true,
    width: 128,
    valuesExport: ['appliedTo']
  },
  {
    isSortable: false,
    field: 'buttons',
    title: '',
    show: hasAccess([resources.CS_AGENT_ROLLOUT, access.READ]),
    width: 104
  }
];

export const defaultFilters = {
  search: '',
  platform: [],
  arch: [],
  status: []
};

export const defaultNavigation = {
  fieldName: 'version',
  direction: -1,
  currentPage: initialTableShow.currentPage,
  itemsPerPage: initialTableShow.itemsPerPage
};

export const filesTableConf = [
  {
    field: 'objectKey',
    title: 'File Name'
  },
  {
    field: 'arch',
    title: 'Architecture'
  },
  {
    field: 'contentLength',
    title: 'Size'
  },
  {
    field: 'status',
    title: 'Status'
  },
  {
    field: 'createdAt',
    title: 'Release Date'
  },
  {
    field: 'lastModified',
    title: 'Updated At'
  },
  {
    field: 'btn',
    title: ''
  }
];
